



















































































































import { Component, Prop, Mixins } from "vue-property-decorator";
import _ from "@/boot/lodash";

// Mixins
import WebhookTriggersInjectorMixin from "@/mixins/webhookTriggersInjectorMixin";

// Types
import { IWebhookTriggerData } from "@/models/webhooks";

@Component({
  components: {}
})
export default class WebhookTriggerRowItem extends Mixins(
  WebhookTriggersInjectorMixin
) {
  // Props

  @Prop({ default: null })
  public webhookTrigger!: IWebhookTriggerData;

  @Prop({ default: false })
  public isLoading!: boolean;

  // Data

  public limit = 10;
  public showAll = false;

  // Life-cycle methods

  public created() {
    this.showAll = this.selectedHooks.length < this.limit + 3;
  }

  // Computed

  public get showSkeleton() {
    return this.isLoading || _.isNull(this.webhookTrigger);
  }

  public get categoryName() {
    return _.get(this.category, "name", "");
  }

  public get category() {
    return _.find(this.$webhookTriggersData.categories, [
      "id",
      this.webhookTrigger.sync_category_id
    ]);
  }

  public get categoryHooks() {
    return this.category?.hooks;
  }

  public get selectedHooks() {
    if (_.isNull(this.webhookTrigger)) return [];
    if (
      _.some(this.webhookTrigger.subscriptions, trigger =>
        _.isEmpty(trigger.hook_id)
      )
    ) {
      return _.map(this.categoryHooks, categoryHook => {
        return _.pick(categoryHook, ["id", "name"]);
      });
    }

    return _.map(this.webhookTrigger.subscriptions, trigger => {
      return {
        id: trigger.hook_id,
        name: _.get(
          _.find(this.categoryHooks, ["id", trigger.hook_id]),
          "name",
          ""
        )
      };
    });
  }

  public get filteredSelectedHooks() {
    if (this.showAll) return this.selectedHooks;

    return _.slice(this.selectedHooks, 0, this.limit);
  }

  public get invisibleHooks() {
    return (this.selectedHooks?.length || 0) - this.limit;
  }
}
